import Vue from 'vue'
import App from './App.vue'
import router from './router/'
import store from './store/'
import i18n from './i18n'
import '../node_modules/ag-grid-community/dist/styles/ag-grid.css'
import '../node_modules/ag-grid-community/dist/styles/ag-theme-material.css'
import { FETCH_LANGUAGE_LIST, FETCH_VERSIONS, GET_LOAD_INTRO_DATA, LOG_USER_IN_BY_TOKEN } from '@/store/action-types'
import vuetify from '@/plugins/vuetify'
import { Version } from '@/model/Version'
import 'devextreme/dist/css/dx.light.css'

Vue.config.productionTip = false

doInitialization()

async function doInitialization (): Promise<void> {
  const baseURL =  process.env.VUE_APP_API_ROOT || ''

  const favicon: any = document.getElementById('favicon')
  if(favicon) {
    favicon.href = `${baseURL}/api/Configuration?loadFavicon=`
  }

  const response = await store.dispatch(GET_LOAD_INTRO_DATA)
  if(response && response.PrimaryColor && response.PrimaryColor !== localStorage.getItem('primaryColor')) {
    localStorage.setItem('primaryColor', response.PrimaryColor)
  }
  if(response && response.SecondaryColor && response.SecondaryColor !== localStorage.getItem('secondaryColor')) {
    localStorage.setItem('secondaryColor', response.SecondaryColor)
  }

  await fetchVersion()
}

async function fetchVersion (): Promise<void> {
  try {
  const version: Version = await store.dispatch(FETCH_VERSIONS)
    if (version.statusFrontend && version.statusBackend) {
      await logUserByToken()
    } else {
      startVue()
    }
  } catch {
    startVue()
  }
}

async function logUserByToken (): Promise<void> {
  if (localStorage.getItem('token')) {
    try {
      await store.dispatch(LOG_USER_IN_BY_TOKEN)
      await store.dispatch(FETCH_LANGUAGE_LIST)
      startVue()
    } catch (e) {
      startVue()
    }
  } else {
    startVue()
  }
}

function startVue (): void {
  new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}